// extracted by mini-css-extract-plugin
export default {"TooltipIcon":"FormGroupElement_TooltipIcon__QK5x2"};